import Landing from "./landing.controller";
import InRoot from "./inroot.controller";
import ASide from "./aside.controller";
import Header from "./header.controller";
import Footer from "./footer.controller";
import About from "./about.controller";
import Anticheat from "./anticheat.controller";
import Error from "./error.controller";
import User from "./user.controller";
import Pug from "./pug.controller";
import Offscreen from "./offscreen.controller";
import Match from "./lobby.controller";
import Support from "./support.controller";
import Players from "./players.controller";
import ServerView from "./serverview.controller";
import LiveStream from "./livestream.controller";
import Settings from "./settings.controller";
import Matches from "./matches.controller";
import MatchDetails from "./matchdetails.controller";
import Leaderboard from "./leaderboard.controller";
import Bans from "./bans.controller";
import Client from "./client.controller";
import News from "./news.controller";
import Toolbar from "./toolbar.controller";
import Social from "./social.controller";
import Training from "./training.controller";
import Mix from "./pugb.controller";
import Play from "./play.controller";
import Solo from "./solo.controller";
import Home from "./home.controller";
import Lobby from "./lobby.controller";
import Tos from "./tos.controller";
import Privacy from "./privacy.controller";
import Conduct from "./conduct.controller";
import Site from "./site.controller";

const pages = {
  landing: Landing,
  tos: Tos,
  privacy: Privacy,
  conduct: Conduct,
  site: Site,
  inroot: InRoot,
  aside: ASide,
  header: Header, 
  ac: Anticheat,
  error: Error,
  user: User,
  pug: Mix,
  offscreen: Offscreen,
  match: Match,
  support: Support,
  players: Players,
  server: ServerView,
  footer: Footer,
  about: About,
  livestream: LiveStream,
  settings: Settings,
  matches: Matches,
  matchdetails: MatchDetails,
  leaderboard: Leaderboard,
  banlist: Bans,
  client: Client,
  news: News,
  toolbar: Toolbar,
  social: Social,
  training: Training,
  play: Play,
  solo: Solo,
  home: Home,
  lobby: Lobby,
  //mix: Mix,
};

export { pages };